import React from 'react';

import GreenCheckmark from '@/components/shared/GreenCheckmark';
import RedXMark from '@/components/shared/RedXMark';

const walletData = [
  {
    name: 'Gleec Exchange Wallet',
    features: {
      nonCustodial: true,
      openSource: true,
      mobileApp: true,
      browserExtension: true,
      desktopApp: true,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'Trust Wallet',
    features: {
      nonCustodial: true,
      openSource: true,
      mobileApp: true,
      browserExtension: true,
      desktopApp: false,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'MetaMask',
    features: {
      nonCustodial: true,
      openSource: true,
      mobileApp: true,
      browserExtension: true,
      desktopApp: false,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'Exodus',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: true,
      desktopApp: true,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'Coinomi',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: true,
      desktopApp: false,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'Crypto.com',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: true,
      desktopApp: false,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'Guarda Wallet',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: true,
      desktopApp: true,
      multiLanguage: false,
      fiatOnramp: true,
    },
  },
  {
    name: 'Coinbase Wallet',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: true,
      desktopApp: false,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'Edge Wallet',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: true,
      desktopApp: false,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'Zengo',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: false,
      desktopApp: false,
      multiLanguage: false,
      fiatOnramp: true,
    },
  },
  {
    name: 'SafePal',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: true,
      desktopApp: false,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
];

const features = [
  { id: 'nonCustodial', label: 'Non-Custodial' },
  { id: 'openSource', label: 'Open Source' },
  { id: 'mobileApp', label: 'Mobile App' },
  { id: 'browserExtension', label: 'Browser Extension' },
  { id: 'desktopApp', label: 'Desktop App' },
  { id: 'multiLanguage', label: 'Multi Language' },
  { id: 'fiatOnramp', label: 'Fiat On-Ramp' },
];

const WalletComparison = () => {
  return (
    <div className='mx-auto w-full max-w-[95vw]'>
      <div className='overflow-x-auto rounded-lg shadow-lg'>
        <div className='inline-block min-w-full align-middle'>
          <table className='min-w-full border-collapse bg-[#061621]'>
            <colgroup>
              <col className='w-[160px] sm:w-[200px]' />
              {walletData.map((wallet, index) => (
                <col key={`col-${index}`} className='w-[100px] sm:w-[120px]' />
              ))}
            </colgroup>
            <thead>
              <tr className='border-b border-[#919ad5]'>
                <th className='sticky left-0 bg-[#061621] p-1 text-left text-xs font-medium text-[#8B8B8B] sm:text-xs md:p-2 md:text-sm lg:text-sm xl:text-sm 2xl:whitespace-nowrap 2xl:p-3 2xl:text-sm 3xl:text-[15px]'>
                  Feature
                </th>
                {walletData.map((wallet) => (
                  <th
                    key={wallet.name}
                    className={`p-1 text-center text-xs ${wallet.name === 'Gleec Exchange Wallet' ? 'border-l-[4px] border-r-[4px] border-t-[4px] border-l-[#06b6d4] border-r-[#06b6d4] border-t-[#06b6d4] bg-gradient-to-b from-[#0a2540] to-[#051621] font-bold text-[#06b6d4] shadow-[0_0_20px_rgba(6,182,212,0.3)]' : 'font-medium text-[#289fc6]'} sm:text-xs md:p-2 md:text-sm lg:text-sm xl:text-sm 2xl:whitespace-nowrap 2xl:p-3 2xl:text-sm 3xl:text-[15px]`}
                  >
                    {wallet.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className='divide-y divide-[#919ad5] border-b border-r border-[#919ad5]'>
              {features.map((feature, featureIndex) => (
                <tr key={feature.id}>
                  <td className='sticky left-0 bg-[#061621] p-1 text-xs font-medium text-[#289fc6] sm:text-xs md:p-2 md:text-sm lg:text-sm xl:text-sm 2xl:whitespace-nowrap 2xl:p-3 2xl:text-sm 3xl:text-[15px]'>
                    {feature.label}
                  </td>
                  {walletData.map((wallet) => {
                    const isLastRow = featureIndex === features.length - 1;
                    const isKomodo = wallet.name === 'Gleec Exchange Wallet';
                    return (
                      <td
                        key={`${wallet.name}-${feature.id}`}
                        className={`text-center ${isKomodo ? `border-l-[4px] border-r-[4px] border-l-[#06b6d4] border-r-[#06b6d4] ${isLastRow ? 'border-b-[4px] border-b-[#06b6d4]' : ''} bg-gradient-to-b from-[#0a2540] to-[#051621]` : 'border-l border-[#919ad5]'}`}
                      >
                        {wallet.features[feature.id] ? (
                          <span className='flex items-center justify-center p-1 2xl:p-3'>
                            <GreenCheckmark />
                          </span>
                        ) : (
                          <span className='inline-flex items-center justify-center'>
                            <RedXMark />
                          </span>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WalletComparison;
